import { GET_USER_PROFILE } from './ApiConstants';
import api from './ApiHandler';

export const getUserProfile = async (payload: any) => {
  return await api.get(GET_USER_PROFILE);
};
